
import { TextInputProps  } from '../TextInput/textInput.types';
import DefaultProps from '../../commonTypes/defaultprops.types';
import COLORS from '../../style/universal.color';
import Handler from '../../commonTypes/handler.types';

export interface SuggestionsGroup {
    label?: string;
    data: Array<Suggestion>;
    className?: string;
}

export interface Suggestion {
  text: string;
  component?: object;
  className?: string;
}

export interface TypeAheadProps extends DefaultProps, TextInputProps {
    data?: Array<SuggestionsGroup | Suggestion>;
    onItemClick: Function;
    resetHandlers: Handler;
    shouldClearValueOnSelect?: boolean;
}

export interface ListProps {
    theme?: string;
}

export interface IndividualListStyle {
    base: string;
    border: string;
    text: string;
    icon: string;
    hover: string;
}

interface ListColorsMap {
    primary: IndividualListStyle;
    dark: IndividualListStyle;
}

export const ListColors: ListColorsMap = {
    primary: {
        base: COLORS.mlbWhite,
        border: COLORS.mlbGrey7,
        text: COLORS.mlbGrey3,
        icon: COLORS.mlbGrey6,
        hover: COLORS.mlbGrey2
    },
    dark: {
        base: COLORS.mlbGrey7,
        border: COLORS.mlbGrey4,
        text: COLORS.mlbGrey3,
        icon: COLORS.mlbWhite,
        hover: COLORS.mlbGrey6
    }
}
